import React from 'react';
import { NavLink } from 'react-router-dom';
import { QRIcon } from '../common/Icons';
import {
  FiGrid,
  FiHome,
  FiBriefcase,
  FiShoppingBag,
  FiLayers,
  FiLayout,
  FiCreditCard,
  FiMessageSquare,
  FiSettings
} from 'react-icons/fi';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const menuItems = [
    { label: 'Dashboard', path: '/dashboard', icon: FiHome, end: true },
    { label: 'Business Profile', path: '/dashboard/business', icon: FiBriefcase },
    { label: 'Products', path: '/dashboard/products', icon: FiShoppingBag },
    { label: 'Categories', path: '/dashboard/categories', icon: FiLayers },
    { label: 'Themes & Customizer', path: '/dashboard/themes', icon: FiLayout },
    { label: 'Digital Card', path: '/dashboard/digital-card', icon: FiCreditCard },
    { label: 'QR Code Generator', path: '/dashboard/qr-code', icon: QRIcon },
    { label: 'Customer Enquiries', path: '/dashboard/enquiries', icon: FiMessageSquare },
    { label: 'Settings', path: '/dashboard/settings', icon: FiSettings }
  ];

  return (
    <aside className={`dashboard-sidebar ${isOpen ? 'mobile-open' : ''}`}>
      <div className="dashboard-sidebar-header">
        <div className="sidebar-logo">
          {/* <div className="sidebar-logo-icon">
            <FiGrid />
          </div>
          <span>Digital Business</span> */}
          <img src='/assets/dashlogo.png' alt='' />
        </div>
      </div>

      <nav className="dashboard-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              onClick={() => toggleSidebar(false)}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon className="nav-item-icon" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;